export default "__VITE_ASSET__BdyPrCKA__"